// export * from "./state"
// export * from "./store"
import Vue from 'vue'
import * as Vuex from "vuex"
import { State } from "./state"
import { auth } from "./auth.module"
import { user } from "./user.module"
import { activity } from "./activity.module"
import { data } from "./data.module"
import { temp } from "./temp.module"

Vue.use(Vuex)

export const store = new Vuex.Store<State>({
    modules: {
        auth,
        user,
        activity,
        data,
        temp
    }
});